module.exports = __webpack_public_path__ + "static/media/Sports_grounds_Belfast.af242118.jpg";